import { useMediaQuery } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchUser } from "reduxStore/actions/userActions";

export const useProfilePage = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user);
  const userId = user._id;

  const isLargeScreen = useMediaQuery("(min-width:1000px)");

  useEffect(() => {
    dispatch(fetchUser(userId));
  }, [dispatch, userId]);

  return {
    isLargeScreen,
    user,
  };
};
